import { useGetChatCredentials } from "~/services";

export default (skip = false) => {
  const { credentials, loading } = useGetChatCredentials({ skip });
  return {
    chatToken: credentials?.token,
    chatKeys: credentials?.keys,
    chatUUID: credentials?.uuid,
    callChannels: credentials?.callChannels,
    loading,
  };
};
